import type { UiOrganizationUser } from '../../schemas/organizationUser/organization.user.schema';

/**
 * The account's membership row for the SELECTED organization — the org-scoped
 * answer to "what am I here", as opposed to `currentUser.type`, which `/auth/me`
 * fills from the first row across ALL of the account's organizations.
 *
 * ACTIVE rows win: `OrganizationUsers` has a NON-unique (organizationId, userId)
 * index, so one account can hold several rows for one org — an ARCHIVED
 * ex-OWNER row alongside the ACTIVE CLIENT one. Taking whichever came first
 * would describe the account by a membership it no longer has. A non-active row
 * is still returned when it is the only one, so callers can tell "was a member"
 * from "never was".
 */
export const pickOrgMembership = (
  memberships: undefined | null | UiOrganizationUser[],
  organizationId: undefined | null | string,
): undefined | UiOrganizationUser => {
  if (!memberships?.length || !organizationId) return undefined;
  const forOrganization = memberships.filter(
    (membership) => membership.organizationId === organizationId,
  );
  return (
    forOrganization.find((membership) => membership.status === 'ACTIVE') ??
    forOrganization[0]
  );
};
